module.exports = {
      id: "smartphone-usage",
      viewBox: "0 0 10 18",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#smartphone-usage",
      toString: function () {
        return this.url;
      }
    }